import { useCallback, useSyncExternalStore } from 'react'

import { secondsUntil } from '../../lib/format'

/**
 * Whole seconds left of a `Retry-After` wait (0 when there is none), ticking
 * once a second while it runs. An external store rather than state, so the
 * first frame of a notice already counts from the right instant -- not from
 * when the drawer happened to mount -- without reading the clock in render.
 */
export function useSecondsUntil(retryAt: number | null): number {
  const subscribe = useCallback(
    (notify: () => void) => {
      if (retryAt === null) return () => {}
      const tick = window.setInterval(notify, 1000)
      return () => window.clearInterval(tick)
    },
    [retryAt],
  )
  return useSyncExternalStore(subscribe, () => (retryAt === null ? 0 : secondsUntil(retryAt, Date.now())))
}
